/* eslint-disable react-hooks/exhaustive-deps */
import { DialogType } from 'commons/Dialog/CustomDialog';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ErrorName } from 'utils/constants/error.name';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { useDialog } from './DialogProvider';

/**
 * Base hook to wrap basic useEffect fetch (with no dependencies) and handle error popup
 * @param serviceRequest a Service function (GET, POST...) returning a json promise
 * @param initialState optional parameter to have an initial response
 * @returns {{isLoading: boolean, response: json, error: json}}
 */
export default function useFetch(serviceRequest, initialState = null) {
  const [response, setResponse] = useState(initialState);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const showDialog = useDialog();
  const history = useHistory();
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const json = await serviceRequest();
        setResponse(json);
        setIsLoading(false);
      } catch (errorMessage) {
        setIsLoading(false);
        if (errorMessage === ErrorName.NOT_LABO_USER) {
          showDialog({
            variant: DialogType.ERROR,
            title: localize('authenticationError'),
            description: localize('authenticationErrorDescription')
          });
          history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: localize('authenticationErrorDescription') });
        } else if (errorMessage === 'userNotActivated') {
          showDialog({
            variant: DialogType.ERROR,
            title: localize('authenticationError'),
            description: localize('userNotActivatedErrorDescription')
          });
          history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: localize('userNotActivatedErrorDescription') });
        } else {
          showDialog({
            variant: DialogType.ERROR,
            title: 'error',
            description: errorMessage
          });
        }
        setError(errorMessage);
      }
    };
    fetchData();
  }, []);
  return {
    response,
    error,
    isLoading
  };
}